export default {
  never: 'Niemals',
};
